module.exports = __webpack_public_path__ + "static/media/edit.8b397511.svg";